class FlowmaBusinessData {
    constructor() {
        this.data = {
            en: {
                portalHeader: {
                    tag: "Business Portal",
                    greeting: "Hello,",
                    fallbackName: "Partner",
                    loading: "Initializing Portal..."
                },
                labels: { continue: "Register Customer", back: "Back" },
                errors: {
                    missingId: "Missing Business ID",
                    notFound: "Account Not Found",
                    resolutionError: "Error loading portal data. Please refresh."
                },
                steps: [
                    {
                        id: "business_lead",
                        type: "form",
                        title: "Lead Entry Portal",
                        subtitle: "Sync customer data directly to your Flowma account.",
                        fields: [
                            { name: "fullName", type: "text", label: "Full Name", placeholder: "Enter customer name", required: true },
                            { name: "email", type: "email", label: "Email Address", placeholder: "customer@email.com", required: true },
                            { name: "phone", type: "phone", label: "Phone Number", placeholder: "050-0000000", required: true },
                            { name: "notes", type: "textarea", label: "Internal Notes", placeholder: "Add specific details...", required: false }
                        ]
                    }
                ],
                success: {
                    title: "Data Synced",
                    text: "The customer has been successfully added to your records.",
                    cta: "Add Another Customer"
                }
            },
            he: {
                portalHeader: {
                    tag: "פורטל עסקי",
                    greeting: "שלום,",
                    fallbackName: "שותף יקר",
                    loading: "טוען נתונים..."
                },
                labels: { continue: "רישום לקוח", back: "חזרה" },
                errors: {
                    missingId: "מזהה עסק חסר",
                    notFound: "חשבון לא נמצא במערכת",
                    resolutionError: "שגיאה בטעינת הנתונים. נא לנסות שוב."
                },
                steps: [
                    {
                        id: "business_lead",
                        type: "form",
                        title: "פורטל הזנת לידים",
                        subtitle: "סנכרון פרטי לקוחות ישירות לחשבון ה-Flowma העסקי שלך.",
                        fields: [
                            { name: "fullName", type: "text", label: "שם מלא", placeholder: "הכנס שם לקוח", required: true },
                            { name: "email", type: "email", label: "כתובת אימייל", placeholder: "mail@customer.com", required: true },
                            { name: "phone", type: "phone", label: "טלפון", placeholder: "הכנס מספר טלפון", required: true },
                            { name: "notes", type: "textarea", label: "הערות", placeholder: "פרטים נוספים שחשוב שנכיר...", required: false }
                        ]
                    }
                ],
                success: {
                    title: "הנתונים סונכרנו",
                    text: "הלקוח התווסף בהצלחה לרשימות שלך.",
                    cta: "רישום לקוח נוסף"
                }
            }
        };
    }

    getByLanguage(lang) {
        return this.data[lang] || this.data['en'];
    }
}

export default new FlowmaBusinessData();